import { render, staticRenderFns } from "./RequestInfoModal.vue?vue&type=template&id=20809baa&scoped=true"
import script from "./RequestInfoModal.vue?vue&type=script&lang=js"
export * from "./RequestInfoModal.vue?vue&type=script&lang=js"
import style0 from "./RequestInfoModal.vue?vue&type=style&index=0&id=20809baa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20809baa",
  null
  
)

export default component.exports